module.exports = __webpack_public_path__ + "static/media/2-option3-4row.6a45f843.png";